import {ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {FieldRecord} from "../../../../model/api/field-record";
import {Invoice} from "../../../../model/billing/invoice";
import {BillingService} from "../../../../services/billing/billing.service";
import {InvoiceDetailTableComponent} from "../invoice-detail-table/invoice-detail-table.component";
import {InvoiceOrdersChangeRequest} from "../../../../model/billing/invocie-order-change-request";

@Component({
  selector: 'app-invoice-detail-dialog',
  templateUrl: './invoice-detail-dialog.component.html',
  styleUrls: ['./invoice-detail-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class InvoiceDetailDialogComponent extends CcBaseComponent {

  // fields
  templates: FieldRecord<any>[];

  transPartKey: string = 'billing-detail';

  @Input()
  dialogFormVisible: boolean = false;
  @Output()
  dialogFormVisibleChange = new EventEmitter<boolean>();
  @Output()
  invoiceChange = new EventEmitter<Invoice>();
  @ViewChild('ccInvoiceDetailTable')
  public ccInvoiceDetailTable: InvoiceDetailTableComponent;

  invoice: Invoice;
  stateClass: string = '';

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              private billingService: BillingService,
              private confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, translateService);
  }

  showDialog(invoice: Invoice): void {
    this.invoice = invoice;
    this.stateClass = this.getStateClass(invoice);
    this.dialogFormVisible = true;
    this.dialogFormVisibleChange.emit(true);
    this.markForCheck();
  }

  closeDialog(): void {
    this.dialogFormVisible = false;
    this.dialogFormVisibleChange.emit(false);
    this.markForCheck();
  }

  applyOrdersChange() {
    const toSaveOrders = JSON.parse(JSON.stringify(this.ccInvoiceDetailTable.records));
    let isFullyPaid = true;
    toSaveOrders.forEach(order => {
      if (order.brokerageRateAmount == order.overrideBrokerageRateAmount) {
        order.overrideBrokerageRateAmount = 0;
      }
      if (order.settlementId == 0) {
        isFullyPaid = false;
      }
      if (!order.account) order.account = {};
      order.account.name = order['account_name'];
      order.account.reference1 = order['account_reference1'];
    });
    const request: InvoiceOrdersChangeRequest = {
      invoice: this.invoice,
      orders: toSaveOrders
    };
    if (isFullyPaid) {
      this.confirmationService.confirm({
        header: 'Confirm',
        message: "Invoice will be fully paid. Do you want to continue?",
        icon: 'fas fa-exclamation-triangle',
        acceptLabel: 'Yes',
        acceptButtonStyleClass: 'p-button-primary p-button-sm',
        rejectLabel: 'No',
        rejectButtonStyleClass: 'p-button-warning p-button-sm',
        accept: () => {
          this.billingService.saveOrders(request).subscribe((value) => {
            this.invoice = value.item;
            this.stateClass = this.getStateClass(this.invoice);
            this.ccInvoiceDetailTable.refreshTable(this.invoice);
            this.invoiceChange.emit(this.invoice);
            this.closeDialog();
          });
        },
        reject: () => {
        }
      });
    } else {

      this.billingService.saveOrders(request).subscribe((value) => {
        this.invoice = value.item;
        this.stateClass = this.getStateClass(this.invoice);
        this.ccInvoiceDetailTable.refreshTable(this.invoice);
        this.invoiceChange.emit(this.invoice);
        this.closeDialog();
      });
    }
  }

  cancelOrdersChange() {
    this.ccInvoiceDetailTable.reLoadRecords();
    this.closeDialog();
  }

  public isEditable() {
    return this.invoice.invoiceState === Invoice.InvoiceState.UNPAID ||
      this.invoice.invoiceState === Invoice.InvoiceState.PART_PAID ||
      this.invoice.invoiceState === Invoice.InvoiceState.ON_HOLD;
  }

  getStateClass(record: Invoice) {
    if (Invoice.InvoiceState.CANCELLED === record.invoiceState)
      return "state-cancelled";
    else if (Invoice.InvoiceState.UNPAID === record.invoiceState)
      return "state-unpaid";
    else if (Invoice.InvoiceState.FULLY_PAID === record.invoiceState)
      return "state-paid";
    else if (Invoice.InvoiceState.PART_PAID === record.invoiceState)
      return "state-partial";
    else if (Invoice.InvoiceState.UNBILLED === record.invoiceState)
      return "state-unbilled";
    else if (Invoice.InvoiceState.ON_HOLD === record.invoiceState)
      return "state-onhold";
  }
}
